<div class="vtr-menu-main">
	<nav class="navbar navbar-expand-xl pr-0">
		<div class="navbar-brand p-0">
			<svg xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 256 256">
				<defs>
					<style>
						.a {
							fill: #e1140a;
						}

						.b {
							fill: #fff;
						}

						.c {
							fill: #590804;
						}
					</style>
				</defs>
				<rect class="a"
					width="256"
					height="256" />
				<polygon class="b"
					points="197.43 166.56 119.26 166.56 119.26 35.43 84.4 35.43 84.4 198.14 197.43 198.14 197.43 166.56" />
				<polygon class="c"
					points="54.6 215.2 84.4 198.14 197.43 198.14 54.6 215.2" />
				<polygon class="c"
					points="54.6 215.2 84.4 198.14 84.4 41.78 54.6 215.2" />
			</svg>
		</div>
		<div class="navbar-text clearfix">
			<span>
				<div class="device-type">
					<span *ngIf="!machineFamilyName">&nbsp;</span>
					<span role="text"
						*ngIf="machineFamilyName">{{machineFamilyName}}</span>
					<vtr-ui-header-warranty *ngIf="machineFamilyName"
						[pageParent]="'NavBar'"></vtr-ui-header-warranty>
				</div>
			</span>

		</div>
		<a id="menu-main-btn-navbar-toggler"
			aria-label="menu-main-btn-navbar-toggler"
			[attr.aria-expanded]="showMenu"
			class="navbar-toggler"
			tabindex="1"
			role="button"
			type="button"
			(click)="toggleMenu($event)"
			(keydown.enter)="toggleMenu($event)">
			<span class="navbar-toggler-icon">
				<fa-icon [icon]="['fas', 'bars']"
					role="img"
					aria-label="toggle"></fa-icon>
			</span>
			<!-- <fa-icon [icon]="['fas', 'bars']">
					</fa-icon> -->
		</a>
		<div class="collapse navbar-collapse"
			*ngIf="!loadMenuItem?.hideMenus"
			#menuTarget
			[ngClass]="{'show':showMenu}">
			<ul class="navbar-nav ml-auto"
				*ngIf="loadMenuItem?.firstRunDate?.length || !deviceService.isShellAvailable">
				<ng-container *ngFor="let item of items; let i=index">
					<li *ngIf="item.subitems.length===0&&isCommomItem(item)&&showItem(item)"
						class="nav-item">
						<a class="nav-link {{item.id}}"
							tabindex="1"
							id="menu-main-nav-lnk-{{item.id}}"
							[attr.aria-label]="item.id"
							routerLink="{{item.path}}"
							routerLinkActive="active"
							href="javascript:void(0)"
							(click)="onMenuItemClick(item)"
							(keydown.enter)="onMenuItemClick(item); menuItemKeyDown(item.path)"
							(focus)="closeAllDD()"
							*ngIf="item.label | translate">							
							{{item.label | translate}}
						</a>
						<span class="outline"></span>
					</li>
					<li ngbDropdown
						#menuDropDown="ngbDropdown"
						*ngIf="item.subitems.length>0
						&&isCommomItem(item)
						&&showItem(item)"
						class="nav-item dropdown"
						(mouseover)="[closeAllOtherDD(menuDropDown),menuDropDown.open()]"
						(mouseleave)="menuDropDown.close()"
						[ngClass]="{'active': isParentActive(item)}">
						<a ngbDropdownToggle
							class="nav-link dropdown-toggle {{item.id}}"
							[ngClass]="{'dropdown-toggle': false}"
							tabindex="1"
							id="menu-main-nav-lnk-dropdown-toggle-{{item.id}}"
							attr.aria-label="{{item.id}}"
							routerLink="{{item.path}}"
							routerLinkActive="active"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
							href="javascript:void(0)"
							(focus)="onFocusMenuDropDown(menuDropDown)"
							(click)="onMenuItemClick(item);"
							(keydown.enter)="[onMenuItemClick(item),menuItemKeyDown(item.path)]"
							role="menu"
							*ngIf="item.label | translate">							
							{{item.label | translate}}
						</a>
						<span class="outline"></span>
						<div ngbDropdownMenu
							id="menu-main-nav-lnk-dropdown-toggle-{{item.id}}"
							class="dropdown-menu"
							aria-labelledby="menu-main-nav-lnk-dropdown-toggle-{{item.id}}">
							<span *ngFor="let subitem of item.subitems; let ii=index">
								<a ngbDropdownItem
									*ngIf="subitem.externallink && showItem(subitem)"
									tabindex="1"
									id="menu-main-nav-lnk-dropdown-menu-external-{{item.id}}-{{ii}}"
									attr.aria-label="{{subitem.label | translate }}"
									routerLinkActive="link-active"
									[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
									class="dropdown-item link"
									target="_blank"
									rel="noopener"
									href="javascript:void(0)"
									(keydown)="showHideMenuOfItem($event,menuDropDown)"
									(click)="[onMenuItemClick(subitem),openExternalLink(subitem.path)]"
									(keydown.enter)="[onMenuItemClick(subitem), openExternalLink(subitem.path)]">{{subitem.label | translate}}</a>
								<a ngbDropdownItem
									*ngIf="!subitem.externallink && showItem(subitem)"
									tabindex="1"
									id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{ii}}"
									attr.aria-label="{{subitem.label| translate}}"
									routerLinkActive="link-active"
									[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
									class="dropdown-item link"
									routerLink="{{subitem.path}}"
									(click)="onMenuItemClick(subitem)"
									(keydown)="showHideMenuOfItem($event,menuDropDown)"
									(keydown.enter)="[onMenuItemClick(subitem), menuItemKeyDown(item.path, subitem.path)]"
									href="javascript:void(0)"
									role="menuitem">{{subitem.label | translate}}</a>
							</span>

						</div>
					</li>
					<li ngbDropdown
						#menuDropDown="ngbDropdown"
						(focus)="[closeAllOtherDD(menuDropDown),menuDropDown.open()]"
						(mouseover)="[closeAllOtherDD(menuDropDown),menuDropDown.open()]"
						(mouseleave)="menuDropDown.close()"
						*ngIf="item.id==='user' && languageService.isLanguageLoaded && showItem(item)"
						class="nav-item dropdown">

						<a ngbDropdownToggle
							class="nav-link {{item.id}}"
							id="navbarDropdown"
							attr.aria-label="navbarDropdown"
							[ngClass]="{'dropdown-toggle': false}"
							role="menu"
							tabindex="1"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
							href="javascript:void(0)"
							(focus)="[closeAllOtherDD(menuDropDown),menuDropDown.open()]"
							(focus)="onFocusMenuDropDown(menuDropDown)"
							(click)="onMenuItemClick(item)"
							(keydown.enter)="onMenuItemClick(item)">
							<div class="user-initials">L</div>
						</a>
						<span class="outline"></span>
						<div ngbDropdownMenu
							id="menu-main-nav-lnk-dropdown-toggle-{{item.id}}"
							class="dropdown-menu {{item.id}} dropdown-menu-id"
							aria-labelledby="menu-main-nav-lnk-dropdown-toggle-{{item.id}}">
							<span *ngFor="let subitem of item.subitems; let ii=index">
								<a ngbDropdownItem
									*ngIf="!subitem.externallink && !subitem.internallink && showItem(subitem)"
									tabindex="1"
									id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{ii}}"
									attr.aria-label="{{subitem.label| translate}}"
									routerLinkActive="link-active"
									[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
									class="dropdown-item link"
									routerLink="{{subitem.path}}"
									(keydown)="showHideMenuOfItem($event,menuDropDown)"
									(click)="onMenuItemClick(subitem)"
									(keydown.enter)="onMenuItemClick(subitem); menuItemKeyDown(item.path, subitem.path)"
									href="javascript:void(0)"
									role="menuitem">{{subitem.label | translate}}</a>
								<a ngbDropdownItem
									*ngIf="!subitem.externallink && subitem.internallink && showItem(subitem)"
									tabindex="1"
									id="{{subitem.id}}"
									attr.aria-label="{{subitem.label| translate}}"
									class="dropdown-item link"
									(keydown)="showHideMenuOfItem($event,menuDropDown)"
									(click)="onMenuItemClick(subitem); openInternalLink(subitem.path)"
									(keydown.enter)="onMenuItemClick(subitem); openInternalLink(subitem.path)"
									href="javascript:void(0)"
									role="menuitem">{{subitem.label | translate}}</a>
							</span>

						</div>
					</li>
				</ng-container>
			</ul>
			<div class="d-none">
				<img *ngFor="let i of preloadImages"
					[src]="i"
					alt="">
			</div>
		</div>
	</nav>
</div>
